"use strict";

var Reflux = require("reflux");
var Intl = require("intl");
var ReactIntl = require("react-intl");
var ListingSort = require("./listing-sort");
var ListingActions = require("app/shared/actions/listing-actions");
var ListingStore = require("app/shared/stores/listing-store");
var AddButton = require("app/shared/components/Button/add-button");
var DealsVisualizationButtons = require("./deals-visualization-buttons");
var agendorAPI = require("app/util/api/agendor-api");

var Listing = React.createClass({
	mixins: [Reflux.ListenerMixin, ReactIntl.IntlMixin],
	getDefaultProps: function () {
		return {
			env: ListingStore.getDefaultData().env
		};
	},
	getInitialState: function () {
		var defaultState = ListingStore.getDefaultData();
		defaultState.env = this.props.env || defaultState.env;
		defaultState.hideVisualizations = this.props.hideVisualizations || false;

		// this is necessary to not show the emptyList in the
		// first render while the first list is loading
		defaultState.totalResults = -1;

		return defaultState;
	},
	componentDidMount: function() {
		agendorAPI.sessionId = this.props.token;
		this.listenTo(ListingStore, this.setState);
	},
	getActiveFilterNames: function () {
		var names = [];
		if (this.state.filterValues) {
			for (var key in this.state.filterValues) {
				var filterValue = this.state.filterValues[key];
				if (filterValue.value && filterValue.filterLabel && names.indexOf(filterValue.filterLabel) == -1) {
					names.push(filterValue.filterLabel);
				}
			}
		}
		return names;
	},
	render: function(){
		var queryFilter = (this.state.filterValues.q)? this.state.filterValues.q.value : null;
		var filters = this.getActiveFilterNames();

		var isDealOrPersonSubEnv = (this.state.subEnv=="deal"||this.state.subEnv=="person");

		//EMPTY RESULTSET
		//OR FIRST USE
		if (this.state.totalResults == 0) {
			var isFirstUse = (filters.length<=0 && !queryFilter);
			return (
			<div className="listing">
				{((this.state.env=="deal" && !isDealOrPersonSubEnv) && isFirstUse )?<div className="u-clear"></div>:null}
				<ListingEmptyList isFirstUse={isFirstUse} filters={filters} filterValues={this.state.filterValues} env={this.state.env} addButtonProps={this.props.addButtonProps} inspirationalQuote={this.state.inspirationalQuote} hideVisualizations={this.state.hideVisualizations} />
			</div>
			);
		} else {
			return (
				<div className="listing mb-20">
					<input type="hidden" ref="orderBy" name="orderBy" id="orderBy" value={this.state.orderBy.value} />

					<div className='d-f jc-sb'>
						<AddButton {...this.props}/>

						{(this.state.env=="deal"&&!this.state.hideVisualizations)?<DealsVisualizationButtons selectedIndex={1} />:null}
					</div>

					{(isDealOrPersonSubEnv && this.state.totalResults > 0) ?
						<div className="form-group pull-right">
							<ListingSort orderBy={this.state.orderBy} env={this.props.env} />
						</div>
					:null}
				</div>
			);
		}
	}
});

var ListingEmptyList = React.createClass({
	mixins: [ReactIntl.IntlMixin],
	getDefaultProps: function () {
		return {
			filterValues: {},
			filters: []
		};
	},
	chooseMessage: function (queryFilter) {
		if (queryFilter) {
			return this.getIntlMessage("list_empty.with_query_filter");
		} else {
			return this.getIntlMessage("list_empty.no_query_filter");
		}
	},
	render: function () {
		var queryFilter = (this.props.filterValues.q)? this.props.filterValues.q.value : null;
		var filters = this.props.filters;

		//FIRST USE
		if(this.props.isFirstUse) {
			var title = this.getIntlMessage("listing.first_use.title");
			var subtitle = this.getIntlMessage("listing.first_use.subtitle");
			var formattedTitle = this.formatMessage(title, { env: this.props.env });
			var formattedSubtitle = this.formatMessage(subtitle, { env: this.props.env });
			return (
			<div>
				<div className='d-f jc-sb'>
					<AddButton {...this.props}/>
					{(this.props.env=="deal"&&!this.props.hideVisualizations)?<DealsVisualizationButtons selectedIndex={1} />:null}
				</div>
				<p className="ta-c c-fontGray mt-50">{formattedTitle}</p>
				<p className="ta-c c-fontGray mb-20">{formattedSubtitle}</p>
				<span className="custom-glyphicon icon-logo listing-agendorLogo"></span>
				<ListingQuote {...this.props.inspirationalQuote} />
				<div className="u-clear"></div>
			</div>
			);

		//EMPTY RESULTSET
		} else {
			var message = this.chooseMessage(queryFilter);
			var formattedMessage = this.formatMessage(message, {
				env: this.props.env,
				q: queryFilter,
				filters: filters.join(", "),
				filtersCount: filters.length
			});
			return (
			<div>
				<div className='d-f jc-sb'>
					<AddButton {...this.props}/>
					{(this.props.env=="deal"&&!this.props.hideVisualizations)?<DealsVisualizationButtons selectedIndex={1} />:null}
				</div>
				<div className="listing-emptyListMessage" dangerouslySetInnerHTML={{__html: formattedMessage}}></div>
				<span className="custom-glyphicon icon-logo listing-agendorLogo"></span>
				<ListingQuote {...this.props.inspirationalQuote} />
				<div className="u-clear"></div>
			</div>
			);
		}
	}
});

var ListingQuote = React.createClass({
	componentDidMount: function(){
		ListingActions.loadQuote();
	},
	render: function(){
		if(!this.props.quote) {
			return null;
		} else {
			return (
				<blockquote className="listing-quote">
				  &quot;{this.props.quote}&quot;
				  <footer><cite>{this.props.author}</cite></footer>
				</blockquote>
			);
		}
	}
});

module.exports = Listing;



// WEBPACK FOOTER //
// ./app/shared/components/List/listing.jsx